const log_details = {
    back_to_logs: 'Audit 기록으로 돌아가기',
    back_to_user: '{{name}}으로 돌아가기',
    success: '성공',
    failed: '실패',
    event_type: '활동 종류',
    application: '어플리케이션',
    ip_address: 'IP 주소',
    user: '사용자',
    log_id: '기록 ID',
    time: '시간',
    user_agent: '사용자 Agent',
    tab_details: '상세',
    raw_data: '상세 데이터',
};
export default log_details;
